<app-modal
  [open]="open"
  [title]="title"
  [message]="null"
  [primaryText]="loading ? 'Importando...' : primaryText"
  [secondaryText]="secondaryText"
  [primaryDisabled]="primaryDisabled || loading"
  (close)="close.emit()"
  (secondary)="cancel.emit()"
  (primary)="confirm.emit()"
>
  <div class="preview">
    <p class="preview-message" *ngIf="message">{{ message }}</p>
    <p class="preview-count" *ngIf="displayRows.length">{{ displayRows.length }} registros</p>

    <div class="preview-table" *ngIf="displayRows.length; else emptyState">
      <table>
        <thead>
          <tr>
            <th *ngFor="let col of columns">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of displayRows">
            <td *ngFor="let col of columns; let i = index">{{ row?.[i] || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyState>
      <p class="preview-empty">Nenhum registro para importar.</p>
    </ng-template>
  </div>
</app-modal>
